import { connectWithStore } from '@common/connectWithStore';
import {
  hideForm,
  toggleTerms,
  submitToBeInTouch,
  confirm,
  getState,
} from '@redux/ducks/account/pricingPlan/changePricingPlan';
import { ChangePricingPlan } from './ChangePricingPlan';

const mapStateToProps = state => {
  const { isShown, isErrorOccurred, isLoading, areTermsShown } = getState(state);

  return {
    isShown,
    isErrorOccurred,
    areTermsShown,
    isLoading,
  };
};

const mapDispatchToProps = {
  submitToBeInTouch,
  onCancel: hideForm,
  onConfirm: confirm,
  onTermsToggleChange: toggleTerms,
};

export const ChangePricingPlanContainer = connectWithStore(mapStateToProps, mapDispatchToProps)(ChangePricingPlan);
